export default "/assets/images/column-image2.641dbea732ff85d8.png";